(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("first-person-controls", [], factory);
	else if(typeof exports === 'object')
		exports["first-person-controls"] = factory();
	else
		root["first-person-controls"] = factory();
})(self, function() {
return 